import { useTranslation } from "@coworker/locales";
import type {
  CarouselAnnouncement,
  SlideShowAnnouncement,
  SlideShowPaginationButtonLabel,
} from "@ingka/carousel";

export const useImageCarouselAccessibility = () => {
  const { t } = useTranslation();
  const carouselLabel = t("imageCarouselString");
  const imageLabel = t("imageString");
  const imagesLabel = t("imagesString");

  const commonAccessibilityProps = {
    ariaLabel: carouselLabel,
    ariaLabelLeftBtn: t("previousImageString"),
    ariaLabelRightBtn: t("nextImageString"),
    skipButtonText: `${t("skipString")}: ${carouselLabel}`,
  };

  return {
    carouselAccessibilityProps: {
      ...commonAccessibilityProps,
      carouselTrackAriaLabel: imagesLabel,
      getLiveAnnouncement: ({
        visibleStart,
        visibleEnd,
        total,
      }: CarouselAnnouncement) =>
        `${imagesLabel} ${visibleStart}–${visibleEnd}/${total}`,
    },
    slideshowAccessibilityProps: {
      ...commonAccessibilityProps,
      getLiveAnnouncement: ({ currentSlide, total }: SlideShowAnnouncement) =>
        `${imageLabel} ${currentSlide}/${total}`,
      getPaginationButtonLabel: ({
        slide,
        total,
      }: SlideShowPaginationButtonLabel) => `${imageLabel} ${slide}/${total}`,
      slideshowTrackAriaLabel: imagesLabel,
    },
  };
};
